// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608281804/js/" + chunkId + "." + {"44":"8bcf4de7","225":"811fd031","481":"fa578232","486":"d72e2cc6","770":"bc2ad50e"}[chunkId] + ".0.5455901404766835.chunk.js";
};